import matchActions from '@/store/modules/storage/registry/matchActions';
import matchRounds from '@/store/modules/storage/registry/matchRounds';
import roundTurns from '@/store/modules/storage/registry/roundTurns';

export default {
    matchActions,
    matchRounds,
    roundTurns,
};
